import { IconButton, Tooltip } from "@mui/material";
import React from "react";

interface IActionButton {
  title: string;
  icon: React.ReactNode;
  action: () => void;
}

const ActionButton = ({ title, icon, action }: IActionButton) => {
  return (
    <Tooltip title={title} placement="bottom">
      <IconButton onClick={() => action()}>{icon}</IconButton>
    </Tooltip>
  );
};

export default ActionButton;
